module.exports = __webpack_public_path__ + "static/media/312124-03a9f4.39cbf57c.svg";